export default {"src":"/_next/static/media/delete-on-hover.a0ef1570.svg","height":11,"width":12,"blurWidth":0,"blurHeight":0};